import {
	BooleanField,
	Datagrid,
	EditButton,
	EmailField,
	ReferenceField,
	ReferenceManyField,
	Show,
	SimpleShowLayout,
	Tab,
	TabbedShowLayout,
	TextField,
	TopToolbar,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { useGlobalPermission } from "../../permissions";

const PostShowActions = () => {
	const userEditPermission = useGlobalPermission("users.update");

	return <TopToolbar>{userEditPermission && <EditButton />}</TopToolbar>;
};

const NoUserTeams = () => (
	<Box textAlign="center" m={2}>
		<Typography variant="body2">
			User has not been assigned to any team or you don't have sufficient
			permissions to see the assignments.
		</Typography>
	</Box>
);

export const UserShow = () => (
	<Show title="User view" actions={<PostShowActions />}>
		<SimpleShowLayout>
			<TextField source="first_name" />
			<TextField source="last_name" />
			<TextField source="kid" label="K-ID" />
			<EmailField source="email" />
			<TextField source="department" />
			<BooleanField source="admin" />
		</SimpleShowLayout>
		<TabbedShowLayout>
			<Tab label="Teams">
				<ReferenceManyField
					label={false}
					reference="team-users"
					target="user_id"
				>
					<Datagrid
						bulkActionButtons={false}
						empty={<NoUserTeams />}
						rowClick={(id, resource, record) => `/teams/${record.team_id}/show`}
					>
						<ReferenceField source="team_id" reference="teams" link="show">
							<TextField source="name" />
						</ReferenceField>
						<ReferenceField source="role_id" reference="roles" link={false}>
							<TextField source="name" />
						</ReferenceField>
					</Datagrid>
				</ReferenceManyField>
			</Tab>
			<Tab label="Channels" path="channels">
				<ReferenceManyField
					label={false}
					reference="channel-users"
					target="user_id"
				>
					<Datagrid bulkActionButtons={false}>
						<ReferenceField
							source="channel_id"
							reference="channels"
							link="show"
							label="Channel"
						>
							<TextField source="name" />
						</ReferenceField>
						<ReferenceField
							source="channel_id"
							reference="channels"
							link={false}
							label="Organ"
						>
							<ReferenceField source="organ_id" reference="organs">
								<TextField source="name" />
							</ReferenceField>
						</ReferenceField>
					</Datagrid>
				</ReferenceManyField>
			</Tab>
		</TabbedShowLayout>
	</Show>
);
